var map = {
	"./demos/basic/index.ts": 76499,
	"./demos/collapse/index.ts": 32708,
	"./demos/loading/index.ts": 81277,
	"./demos/slots/index.ts": 93831,
	"./demos/withBubble/index.ts": 81855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37079;